import { render } from "./EventRemarksModal.vue?vue&type=template&id=2c483579&scoped=true"
import script from "./EventRemarksModal.vue?vue&type=script&lang=js"
export * from "./EventRemarksModal.vue?vue&type=script&lang=js"

import "./EventRemarksModal.vue?vue&type=style&index=0&id=2c483579&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c483579"]])

export default __exports__